import UpdateSupplier from "../../../../components/@groups/suppliers/UpdateSupplier";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SupplierGroupUpdatePage() {

    return (
        <UpdateSupplier 
            routeType={routeTypes.admin}
        />
    )
}       